<template>
 <div class="container mt-3 py-3">
    <h4>Card contenedor</h4>

    <p class="text-dark m-0">Formulario de ejemplo</p>
    <div class="card-content">
        <h1 class="inter-semibold-32 text-gray-medium" style="font-size:1.5rem;">Alta de empleados</h1>
        <form v-on:submit.prevent="eventGuardar" class="mt-5">
            <div class="row">
                <div class="col-12 col-md-4 mt-4">
                    <vs-input
                        label="Apellido Paterno*"
                        placeholder="Perez"
                        v-model.trim="empleado.apellido_paterno"
                        :state=" (validacionApellidoPaterno = getValidationForm('apellido_paterno',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('apellido_paterno',empleado.apellido_paterno,validaciones)"
                        >
                        <template #message-danger v-if="validacionApellidoPaterno" >
                            {{validacionApellidoPaterno.msg}}
                        </template>
                    </vs-input>
                </div>
                <div class="col-12 col-md-4 mt-4">
                    <vs-input
                        label="Apellido Materno*"
                        placeholder="Hernandez"
                        v-model.trim="empleado.apellido_materno"
                        :state=" (validacionApellidoMaterno = getValidationForm('apellido_materno',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('apellido_materno',empleado.apellido_materno,validaciones)"
                    >
                        <template #message-danger v-if="validacionApellidoMaterno" >
                            {{validacionApellidoMaterno.msg}}
                        </template>
                    </vs-input>
                </div>
                <div class="col-12 col-md-4 mt-4">
                    <vs-input
                        label="Nombre*"
                        placeholder="Maria"
                        v-model.trim="empleado.nombre_completo"
                        :state="(validacionNombreCompleto = getValidationForm('nombre_completo',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('nombre_completo',empleado.nombre_completo,validaciones)"
                    >
                        <template #message-danger v-if="validacionNombreCompleto" >
                            {{validacionNombreCompleto.msg}}
                        </template>
                    </vs-input>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-12 col-md-4 mt-4">
                    <vs-select filter label="Pais*" 
                        class="w-100"
                        v-model.number="empleado.pais_id" 
                        :state="(validacionPaidId = getValidationForm('pais_id',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('pais_id',empleado.pais_id,validaciones)"
                    >
                        <vs-option v-for="(item,index) in paises" :key="index" :label="item.desc_pais" :value="item.pais_id">
                            {{item.desc_pais}}
                        </vs-option>
                        <template #message-danger v-if="validacionPaidId" >
                            {{validacionPaidId.msg}}
                        </template>
                    </vs-select>
                </div>
                <div class="col-12 col-md-4 mt-4">
                    <vs-select 
                        filter label="Estado de nacimiento*" 
                        v-model.number="empleado.estado_id" 
                        :state="(validacionEstadoId = getValidationForm('estado_id',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('estado_id',empleado.estado_id,validaciones)"
                    >
                        <vs-option v-for="(item,index) in estados" :key="index" :label="item.desc_estado" :value="item.estado_id">
                            {{item.desc_estado}}
                        </vs-option>
                        <template #message-danger v-if="validacionEstadoId" >
                            {{validacionEstadoId.msg}}
                        </template>
                    </vs-select>
                </div>
                <div class="col-12 col-md-4 mt-4">
                    <vs-select 
                        filter label="Municipio*" 
                        v-model.number="empleado.municipio_id" 
                        :state="(validacionMunicipioId = getValidationForm('municipio_id',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('municipio_id',empleado.municipio_id,validaciones)"
                    >
                        <vs-option v-for="(item,index) in municipios" :key="index" :label="item.desc_municipio" :value="item.municipio_id">
                            {{item.desc_municipio}}
                        </vs-option>
                        <template #message-danger v-if="validacionMunicipioId" >
                            {{validacionMunicipioId.msg}}
                        </template>
                    </vs-select>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-12 col-md-6 mt-4">
                    <vs-input
                        type="date"
                        v-model="empleado.fecha_nacimiento"
                        label="Fecha de nacimiento*"
                        :state="(validacionFechaNacimiento = getValidationForm('fecha_nacimiento',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('fecha_nacimiento',empleado.fecha_nacimiento,validaciones)"
                    >
                        <template #message-danger v-if="validacionFechaNacimiento" >
                            {{validacionFechaNacimiento.msg}}
                        </template>
                    </vs-input>
                </div>
                <div class="col-12 col-md-6 mt-4">
                    <vs-input
                        type="number"
                        v-model.number="empleado.edad"
                        label="Edad"
                        :state="(validacionEdad = getValidationForm('edad',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('edad',empleado.edad,validaciones)"
                        min="0"
                    >
                        <template #message-danger v-if="validacionEdad" >
                            {{validacionEdad.msg}}
                        </template>
                    </vs-input>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col-12 col-md-4 mt-4">
                    <vs-select 
                        filter label="Genero*" 
                        v-model.number="empleado.genero_id" 
                        :state="(validacionGeneroId = getValidationForm('genero_id',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('genero_id',empleado.genero_id,validaciones)"
                    >
                        <vs-option v-for="(item,index) in generos" :key="index" :label="item.desc_genero" :value="item.genero_id">
                            {{item.desc_genero}}
                        </vs-option>
                        <template #message-danger v-if="validacionGeneroId" >
                            {{validacionGeneroId.msg}}
                        </template>
                    </vs-select>
                </div>
                <div class="col-12 col-md-4 mt-4">
                    <vs-select 
                        filter label="Estado Civil*" 
                        v-model.number="empleado.estadoCivil_id" 
                        :state="(validacionEstadoCivilId = getValidationForm('estadoCivil_id',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('estadoCivil_id',empleado.estadoCivil_id,validaciones)"
                    >
                        <vs-option v-for="(item,index) in estadosciviles" :key="index" :label="item.desc_estadocivil" :value="item.estadoCivil_id">
                            {{item.desc_estadocivil}}
                        </vs-option>
                        <template #message-danger v-if="validacionEstadoCivilId" >
                            {{validacionEstadoCivilId.msg}}
                        </template>
                    </vs-select>
                </div>
                <div class="col-12 col-md-4 mt-4">
                    <vs-input
                        label="Telefono celular*"
                        v-model.trim="empleado.telefono_celular"
                        :state="(validacionTelefonoCelular = getValidationForm('telefono_celular',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('telefono_celular',empleado.telefono_celular,validaciones)"
                    >
                        <template #message-danger v-if="validacionTelefonoCelular" >
                            {{validacionTelefonoCelular.msg}}
                        </template>
                    </vs-input>
                </div>
                <div class="col-12 mt-4">
                    <vs-input
                        label="Correo electronico*"
                        v-model.trim="empleado.correo_electronico"
                        :state="(validacionCorreoElectronico = getValidationForm('correo_electronico',validaciones)) ? 'danger' : ''"
                        @blur="individualValidateForm('correo_electronico',empleado.correo_electronico,validaciones)"
                    >
                        <template #message-danger v-if="validacionCorreoElectronico" >
                            {{validacionCorreoElectronico.msg}}
                        </template>
                    </vs-input>
                </div>

            </div>
            <div class="w-100 d-flex justify-content-center mt-5">
                <vs-button type="button" @click="handleLimpiarFormulario()" class="btn-primary-variant-o px-5">Limpiar</vs-button>
                <vs-button type="submit" class="d-block btn-primary-variant px-5 mx-0">Registrar</vs-button>
            </div>
        </form>
    </div>

    <p class="text-dark mt-4 mb-1">Clase card contenedora.</p>
    <code>.card-content</code>
    <p class="text-dark mt-4 mb-1">Codigo de ejemplo para la implementación de la clase.</p>
    
    <div v-highlight><pre class="language-html"><code><script type="text/plain" class="language-markup"><div class="card-content">
    <!-- Contenido.. -->
</div>
</script></code></pre>
    </div>

<!-- ------------------------------------------------------------------------------------------ -->

<p class="text-dark mt-4 mb-1">Clase flexible con diversas resoluciones.
    <span class="badge rounded-pill text-bg-info">Nuevo</span></p>
    <code>.container-xxl</code>
    <!-- <p class="text-dark mt-4 mb-1">Codigo de ejemplo para la implementación de la clase.</p> -->
    
    <div v-highlight><pre class="language-html"><code><script type="text/plain" class="language-markup"><div class="container-xxl">
    <!-- Contenido.. -->
</div>
</script></code></pre>
    </div>
<!--  -->
 </div>
</template>
<script>
import NotificationMixin from '@/mixins/ResourceNotificationMixin.js'
import FormValidationMixin from '@/mixins/formulario/FormValidationMixin.js'
export default {
    created(){
        window.scrollTo(0, 0);
        },
    name:'PxEjemploFormulario',
    mixins:[NotificationMixin,FormValidationMixin],
    data(){
        return{
            bandera:true,
            empleado:{
                apellido_paterno:null,
                apellido_materno:null,
                nombre_completo:null,
                pais_id:0,
                estado_id:0,
                municipio_id:0,
                fecha_nacimiento:null,
                edad:0,
                genero_id:0,
                estadoCivil_id:0,
                telefono_celular:null,
                progenitor:false,
                correo_electronico:null,

            },
            paises:[
                {
                    pais_id:1,
                    desc_pais:'Mexico'
                },
                {
                    pais_id:2,
                    desc_pais:'Venezuela'
                },
                {
                    pais_id:3,
                    desc_pais:'Guatemala'
                }
            ],
            estados:[
                {
                    estado_id:1,
                    desc_estado:'Chiapas'
                },
                {
                    estado_id:2,
                    desc_estado:'Veracruz'
                },
                {
                    estado_id:3,
                    desc_estado:'Oaxaca'
                }
            ],
            municipios:[
                {
                    municipio_id:1,
                    desc_municipio:'Tuxtla Gutierrez'
                },
                {
                    municipio_id:2,
                    desc_municipio:'Ocozocoautla de Espinosa'
                },
                {
                    municipio_id:3,
                    desc_municipio:'Chiapa de Corzo'
                }
            ],
            generos:[
                 {
                    genero_id:1,
                    desc_genero:'Femenino'
                },
                {
                    genero_id:2,
                    desc_genero:'Masculino'
                },
                {
                    genero_id:3,
                    desc_genero:'No especifico'
                }               
            ],
            estadosciviles:[
                 {
                    estadoCivil_id:1,
                    desc_estadocivil:'Solero(a)'
                },
                {
                    estadoCivil_id:2,
                    desc_estadocivil:'Casado(a)'
                }              
            ],
            validaciones:[
                {
                    input:"apellido_paterno", 
                    validaciones : [             
                            v => !!v || 'Requerido',
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"apellido_materno", 
                    validaciones : [             
                            v => !!v || 'Requerido',
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"nombre_completo", 
                    validaciones : [             
                            v => !!v || 'Requerido',              
                            v => (v && v.length <= 10) || 'Limite de caracteres 10',
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"pais_id", 
                    validaciones : [             
                            v => !!v || 'Requerido',
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"estado_id", 
                    validaciones : [             
                            v => !!v || 'Requerido',
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"municipio_id", 
                    validaciones : [             
                            v => !!v || 'Requerido',
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"fecha_nacimiento",
                    validaciones : [             
                            v => !!v || 'Requerido'
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"edad", 
                    validaciones : [],
                    error:false,
                    msg:''
                },
                {
                    input:"genero_id", 
                    validaciones : [             
                            v => !!v || 'Requerido',
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"estadoCivil_id", 
                    validaciones : [             
                            v => !!v || 'Requerido',
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"telefono_celular", 
                    validaciones : [                       
                            v => ( !v || (!!v && v.length <= 10) ) || 'Limite de caracteres 10',
                        ],
                    error:false,
                    msg:''
                },
                {
                    input:"correo_electronico", 
                    validaciones : [                       
                            v => !!v || 'requerido',
                            v => /.+@.+\..+/.test(v) || 'Ingrese un correo electronico valido',
                        ],
                    error:false,
                    msg:''
                },

            ],


            
            htmlvalue: '<div class="',
            htmlvalue2: '">',
            htmlvalue3: '</div>'

        }
    },
    methods:{
        async eventGuardar(){

            if(!this.validateForm(this.empleado,this.validaciones)){
                return
            }

            this.openNotification(
                            null, //posición
                            'success-sh',  // color
                            `<i class="fas fa-check-circle"></i>`, // icono de fontawesome
                            'Notificación', // titulo 
                            'Empleado agregado correctamente',
                            '8000' // contenido
                        );

        },
        handleLimpiarFormulario(){
            this.resetValidationForm(this.validaciones)
            this.empleado = {
                apellido_paterno:null,
                apellido_materno:null,
                nombre_completo:null,
                pais_id:0,
                estado_id:0,
                municipio_id:0,
                fecha_nacimiento:null,
                edad:0,
                genero_id:0,
                estadoCivil_id:0,
                telefono_celular:null,
                progenitor:false,
                correo_electronico:null
            }
        }
    }
}
</script>

<style scoped >
/* 
.vs-input{
    width: 100% !important;
} */

</style>